import { render, staticRenderFns } from "./TurnBubble.vue?vue&type=template&id=56fe6340&scoped=true&"
import script from "./TurnBubble.vue?vue&type=script&lang=js&"
export * from "./TurnBubble.vue?vue&type=script&lang=js&"
import style0 from "./TurnBubble.vue?vue&type=style&index=0&id=56fe6340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe6340",
  null
  
)

export default component.exports